<mib-modal size="sm" [showCloseButton]="false">
  <svg mib-modal-header mib-logo-medinbox class="h-6 text-mib-branding-900"></svg>

  <div mib-modal-content class="text-center">
    <h2 class="text-2xl not-height-medium:text-xl text-mib-branding-900 mb-4">Access declined</h2>
    <p>You chose not to accept the disclaimer.</p>
    <p>Please review and accept it to access Medinbox Intelligence.</p>
  </div>

  <button mib-modal-footer mibButton type="button" class="w-full" (click)="dialogRef.close()">
    <svg mib-icon name="undo-2"></svg>
    Return to disclaimer
  </button>
</mib-modal>
